import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="py-16 px-6 bg-burgundy-deep relative overflow-hidden" data-id="element-91">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-92">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-burgundy rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-93" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-charcoal rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-94" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-96">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair text-gold-light mb-10" data-id="element-97">
            El Protocolo de Higiene Sensorial (PHS)
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-8 text-lg md:text-xl text-cream/90 leading-relaxed max-w-3xl mx-auto font-light" data-id="element-98">
          <p data-id="element-99">
            A diferencia de los consejos genéricos, este método trabaja de
            "Abajo hacia Arriba" (Bottom-Up). No tratamos de convencer a tu
            mente de que quiera intimidad.
          </p>
          <p className="text-xl md:text-2xl font-cormorant italic text-gold" data-id="element-100">
            Hackeamos tu Nervio Vago para que tu cuerpo pase del estado de
            Supervivencia (Alerta) al estado de Recepción (Placer).
          </p>
          <p data-id="element-101">
            En 21 días, le enseñamos a tu biología que ya es seguro volver a
            sentir.
          </p>
        </motion.div>
      </div>
    </section>;
}